import React, { useEffect } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import Header from "../components/Header";

function NoRatings() {
  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");
  }, [user, loading, error, navigate]);
  //console.log(ratings);
  
    return (
      <>
      {loading === false ? (
      <div className="d-flex align-items-center flex-column mb-0 px-3 splashscreen">
  
        <Header key="1"  user={user} />
  
        <div className="no_ratings px-2 pt-5 mt-5">
          <div className="mb-3 text-center">You haven't rated anything yet.</div>
          <a className="add_rating" href="/add_rating">+</a>
          <div className="mt-3 text-center">Rate something!</div>
        </div>
  
      </div>
      ) : (
      <div className="loadingscreen">
        <div className="loading spinner-border text-warning"></div>
      </div>
      ) }
      </>
    );
  
}



export default NoRatings;
